import objectParser from "../utils/object-parser";

const elements = document.querySelectorAll('.js-AddClassOnScroll');

elements.forEach(element => {
  const { className, scrollDistance } = objectParser(element.dataset);

  if( typeof scrollDistance === 'undefined' ) {
    console.error("[data-scroll-distance] not defined on element")
    return;
  }
  document.addEventListener('scroll', e => {
    if (window.scrollY > scrollDistance) {
      element.classList.add(className);
    } else {
      element.classList.remove(className);
    }
  }, { passive: true })
})